module.exports = __webpack_public_path__ + "img/noDataIcon.b9f3a6d5.png";